export const GAZETTE_COVER_IMAGE_PREFIX = '/.quotion/themes/gazette/images/';

export function getCoverImageTheme(src: string) {
  return src.startsWith(GAZETTE_COVER_IMAGE_PREFIX) ? 'Gazette' : undefined;
}
